import { checkIfIsArray } from '@e-socna/utils';

import type {
  ListFieldMaybeEmptyValue,
  UniqueOrListMaybeEmptyFieldValue,
} from '../types/field-value.type';

export const checkIfIsMultiple = (
  value: UniqueOrListMaybeEmptyFieldValue,
): value is ListFieldMaybeEmptyValue => checkIfIsArray(value);
